@let isMobile = deviceService.isMobile$ | async;

<tui-elastic-container>
  <div
    class="flex flex-col x-white"
    [ngClass]="isMobile ? 'gap-4 p-3' : 'gap-6 p-[20px]'"
  >
    <!-- Header -->
    <div class="flex flex-col gap-2">
      <h1
        [ngClass]="
          isMobile
            ? 'text-[20px]/[24px] font-extrabold'
            : 'text-[28px]/[24px] font-extrabold'
        "
      >
        Отладка регламентов
      </h1>
      <p
        [ngClass]="isMobile ? 'x-font-body-4' : 'x-font-body-3'"
        class="x-text-dark-75"
      >
        Заявка:
        <span
          [ngClass]="isMobile ? 'x-font-body-4-bold' : 'x-font-body-3-bold'"
          >{{ $request().requestNumber }}</span
        >
      </p>
    </div>

    <!-- Section 1: All Available Workflows -->
    <section class="x-white box-border">
      <tui-accordion class="w-full" [closeOthers]="false">
        <button
          type="button"
          class="card-shadow w-full"
          [(tuiAccordion)]="$accordionStates.allWorkflows"
        >
          <div
            [ngClass]="
              isMobile ? 'x-font-body-3-bold my-1' : 'x-font-body-1-bold my-2'
            "
          >
            Все доступные регламенты в системе ({{ $allWorkflows().length }})
          </div>
        </button>

        <tui-expand class="card-shadow">
          <div [ngClass]="isMobile ? 'pt-2' : 'pt-4'">
            @if ($allWorkflows().length === 0) {
              <p
                [ngClass]="isMobile ? 'x-font-body-4' : 'x-font-body-3'"
                class="x-text-dark-75"
              >
                Регламенты не найдены
              </p>
            } @else {
              <tui-scrollbar class="max-h-[300px]">
                <div
                  [ngClass]="
                    isMobile ? 'flex flex-col gap-2' : 'flex flex-col gap-3'
                  "
                >
                  @for (workflow of $allWorkflows(); track workflow.id) {
                    <div
                      class="flex gap-3 rounded-xl transition-colors items-center"
                      [ngClass]="{
                        'x-white-secondary': isWorkflowSelected(workflow.id),
                        'bg-(--tui-status-positive-pale)': isWorkflowAttached(
                          workflow.id
                        ),
                        'p-2': isMobile,
                        'p-3': !isMobile,
                      }"
                    >
                      <input
                        type="checkbox"
                        [ngClass]="isMobile ? 'mt-0 h-5 w-5' : 'mt-1 h-4 w-4'"
                        class="rounded flex-shrink-0"
                        [class.cursor-pointer]="
                          !isWorkflowAttached(workflow.id)
                        "
                        [class.cursor-not-allowed]="
                          isWorkflowAttached(workflow.id)
                        "
                        [checked]="
                          isWorkflowSelected(workflow.id) ||
                          isWorkflowAttached(workflow.id)
                        "
                        [disabled]="isWorkflowAttached(workflow.id)"
                        (change)="toggleWorkflowSelection(workflow.id)"
                      />
                      <div class="flex-1 min-w-0">
                        <div
                          [ngClass]="
                            isMobile
                              ? 'x-font-body-4-bold'
                              : 'x-font-body-3-bold'
                          "
                          class="break-words"
                        >
                          {{ workflow.publicName }}
                          @if (isWorkflowAttached(workflow.id)) {
                            <span
                              class="x-font-body-5 x-text-green ml-2 whitespace-nowrap"
                            >
                              (прикреплен)
                            </span>
                          }
                        </div>
                        @if (!isMobile) {
                          <div class="x-font-body-4 x-text-dark-75 break-all">
                            ID: {{ workflow.id }}
                          </div>
                        }
                        @if (workflow.description && !isMobile) {
                          <div class="x-font-body-4 x-text-dark-75 mt-1">
                            {{ workflow.description }}
                          </div>
                        }
                        <div class="x-font-body-4 x-text-dark-75 break-all">
                          Создан:
                          {{ workflow.createdAt | date: 'HH:mm, dd.MM.yyyy' }}г.
                        </div>
                      </div>
                      @if ($canManageWorkflowsSetup()) {
                        <button
                          tuiIconButton
                          type="button"
                          appearance="secondary-destructive"
                          [size]="isMobile ? 'xs' : 's'"
                          iconStart="@tui.trash-2"
                          [tuiHint]="
                            isWorkflowAttached(workflow.id)
                              ? 'Удалить нельзя - регламент прикреплен'
                              : 'Удалить'
                          "
                          [disabled]="
                            isWorkflowAttached(workflow.id) ||
                            $deletingWorkflowId() === workflow.id
                          "
                          [loading]="$deletingWorkflowId() === workflow.id"
                          (click)="deleteWorkflow(workflow.id)"
                          aria-label="Удалить регламент"
                          class="flex-shrink-0"
                          [ngClass]="isMobile ? 'mt-0' : ''"
                        ></button>
                      }
                    </div>
                  }
                </div>
              </tui-scrollbar>

              <div
                class="border-t border-(--tui-background-neutral-1-hover)"
                [ngClass]="isMobile ? 'mt-2 pt-2' : 'mt-4 pt-4'"
              >
                <button
                  tuiButton
                  type="button"
                  appearance="primary"
                  [size]="isMobile ? 's' : 'm'"
                  [disabled]="$selectedWorkflowIds().size === 0"
                  [loading]="$isLoadingAttach()"
                  (click)="attachSelectedWorkflows()"
                  class="w-full"
                >
                  Прикрепить{{ isMobile ? '' : ' выбранные' }} ({{
                    $selectedWorkflowIds().size
                  }})
                </button>
              </div>
            }
          </div>
        </tui-expand>
      </tui-accordion>
    </section>

    <!-- Section 2: Request Workflows -->
    <section class="x-white box-border">
      <tui-accordion class="w-full" [closeOthers]="false">
        <button
          type="button"
          class="card-shadow w-full"
          [(tuiAccordion)]="$accordionStates.requestWorkflows"
        >
          <div
            [ngClass]="
              isMobile ? 'x-font-body-3-bold my-1' : 'x-font-body-1-bold my-2'
            "
          >
            Регламенты текущей заявки ({{ $requestWorkflows().length }})
          </div>
        </button>

        <tui-expand class="card-shadow">
          <div [ngClass]="isMobile ? 'pt-2' : 'pt-4'">
            @if ($requestWorkflows().length === 0) {
              <p
                [ngClass]="
                  isMobile ? 'x-font-body-4 -mt-2' : 'x-font-body-3 -mt-4'
                "
                class="x-text-dark-75"
              >
                К заявке не прикреплено регламентов
              </p>
            } @else {
              <tui-scrollbar class="max-h-[300px]">
                <div
                  [ngClass]="
                    isMobile ? 'flex flex-col gap-2' : 'flex flex-col gap-3'
                  "
                >
                  @for (
                    requestWorkflow of $requestWorkflows();
                    track requestWorkflow.id
                  ) {
                    <div
                      class="flex items-start gap-2 x-white-secondary rounded-xl"
                      [ngClass]="isMobile ? 'p-2' : 'p-3 gap-3'"
                    >
                      <div class="flex-1 min-w-0">
                        <div
                          [ngClass]="
                            isMobile
                              ? 'x-font-body-4-bold'
                              : 'x-font-body-3-bold'
                          "
                          class="break-words"
                        >
                          {{
                            requestWorkflow.workflowVersion?.workflow
                              ?.publicName
                          }}
                        </div>
                        @if (!isMobile) {
                          <div class="x-font-body-4 x-text-dark-75 break-all">
                            RequestWorkflow ID:
                            {{ requestWorkflow.id }}
                          </div>
                          <div class="x-font-body-4 x-text-dark-75 break-all">
                            Workflow ID:
                            {{ requestWorkflow.workflowVersion?.workflowId }}
                          </div>
                        }
                        @if (requestWorkflow.state) {
                          <div [ngClass]="isMobile ? 'mt-1' : 'mt-2'">
                            <span
                              class="inline-block px-2 py-1 rounded"
                              [ngClass]="
                                isMobile
                                  ? 'x-font-body-5-bold text-[10px]'
                                  : 'x-font-body-5-bold'
                              "
                              [class.x-bg-green]="
                                requestWorkflow.state === 'completed'
                              "
                              [class.x-bg-yellow]="
                                requestWorkflow.state === 'inProgress'
                              "
                              [class.x-text-01]="requestWorkflow.state"
                            >
                              {{ requestWorkflow.state }}
                            </span>
                          </div>
                        }
                      </div>
                      <button
                        tuiIconButton
                        type="button"
                        appearance="secondary-destructive"
                        [size]="isMobile ? 'xs' : 's'"
                        iconStart="@tui.unlink"
                        tuiHint="Открепить"
                        [loading]="isWorkflowDetaching(requestWorkflow.id)"
                        [disabled]="isWorkflowDetaching(requestWorkflow.id)"
                        (click)="detachWorkflow(requestWorkflow.id)"
                        class="flex-shrink-0"
                        [ngClass]="isMobile ? 'mt-0' : ''"
                      ></button>
                    </div>
                  }
                </div>
              </tui-scrollbar>

              <div
                class="border-t border-(--tui-background-neutral-1-hover)"
                [ngClass]="isMobile ? 'mt-2 pt-2' : 'mt-4 pt-4'"
              >
                <button
                  tuiButton
                  type="button"
                  appearance="secondary"
                  [size]="isMobile ? 's' : 'm'"
                  [loading]="$isLoadingDetach()"
                  (click)="detachAllWorkflows()"
                  class="w-full"
                >
                  Открепить все{{ isMobile ? '' : ' регламенты' }}
                </button>
              </div>
            }
          </div>
        </tui-expand>
      </tui-accordion>
    </section>

    <!-- Section 3: Clear Data -->
    @if (isDevelopMode() && $requestWorkflows().length > 0) {
      <section
        class="x-white box-border card-shadow"
        [ngClass]="isMobile ? 'p-3' : 'p-[20px]'"
      >
        <div>
          <h3
            [ngClass]="isMobile ? 'x-font-body-3-bold' : 'x-font-body-1-bold'"
            class="x-text-red"
          >
            Сброс данных
          </h3>
          <h4
            [ngClass]="isMobile ? 'x-font-body-4-bold' : 'x-font-body-2-bold'"
            class="x-text-red mb-2"
          >
            Не работает в продакшене!
          </h4>
          <p
            [ngClass]="isMobile ? 'x-font-body-4 mb-3' : 'x-font-body-3 mb-4'"
            class="opacity-90 max-w-[600px]"
          >
            Полностью сбрасывает заявку и регламенты: удаляет сабмиты и
            прогресс, очищает адрес доставки, возвращает статус "В работе",
            сбрасывает даты завершения, помечает продукты как незавершённые и
            удаляет детали сделки.
          </p>
          <button
            tuiButton
            type="button"
            appearance="accent"
            [size]="isMobile ? 's' : 'm'"
            [loading]="$isLoadingClear()"
            (click)="clearAllWorkflowsData()"
            class="x-bg-danger w-full"
          >
            Сбросить {{ isMobile ? 'данные' : 'данные регламентов и заявки' }}
          </button>
        </div>
      </section>
    }

    <!-- Section 4: Import Workflow -->
    @if ($canManageWorkflowsSetup()) {
      <section class="x-white box-border">
        <tui-accordion class="w-full" [closeOthers]="false">
          <button
            type="button"
            class="card-shadow w-full"
            [(tuiAccordion)]="$accordionStates.importWorkflow"
          >
            <div
              [ngClass]="
                isMobile ? 'x-font-body-3-bold my-1' : 'x-font-body-1-bold my-2'
              "
            >
              Импорт регламента
            </div>
          </button>

          <tui-expand class="card-shadow">
            <div>
              @if (!$showImportUI()) {
                <p
                  [ngClass]="
                    isMobile ? 'x-font-body-4 mb-3' : 'x-font-body-3 mb-4'
                  "
                  class="x-text-dark-75"
                >
                  Создайте новый регламент, импортировав его из JSON
                </p>
                <button
                  tuiButton
                  type="button"
                  appearance="primary"
                  [size]="isMobile ? 's' : 'm'"
                  (click)="toggleImportUI()"
                  class="w-full"
                >
                  Открыть форму импорта
                </button>
              } @else {
                <div
                  [ngClass]="
                    isMobile ? 'flex flex-col gap-3' : 'flex flex-col gap-4'
                  "
                >
                  <p
                    [ngClass]="isMobile ? 'x-font-body-4' : 'x-font-body-3'"
                    class="x-text-dark-75"
                  >
                    Вставьте JSON регламента для создания нового workflow в
                    системе
                  </p>

                  <tui-textfield class="w-full">
                    <textarea
                      tuiTextarea
                      placeholder="Вставьте JSON здесь..."
                      [min]="isMobile ? 8 : 12"
                      [max]="40"
                      [ngModel]="$importJsonInput()"
                      (ngModelChange)="$importJsonInput.set($event)"
                    ></textarea>
                  </tui-textfield>

                  <div
                    class="flex"
                    [ngClass]="isMobile ? 'flex-col gap-2' : 'gap-3'"
                  >
                    <button
                      tuiButton
                      type="button"
                      appearance="primary"
                      [size]="isMobile ? 's' : 'm'"
                      [loading]="$isLoadingImport()"
                      [disabled]="
                        !$importJsonInput().trim() || $isLoadingImport()
                      "
                      (click)="importWorkflow()"
                      [ngClass]="isMobile ? 'w-full' : 'flex-1'"
                    >
                      Создать регламент
                    </button>
                    <button
                      tuiButton
                      type="button"
                      appearance="secondary"
                      [size]="isMobile ? 's' : 'm'"
                      [disabled]="$isLoadingImport()"
                      (click)="cancelImport()"
                      [ngClass]="isMobile ? 'w-full' : 'flex-1'"
                    >
                      Отмена
                    </button>
                  </div>
                </div>
              }
            </div>
          </tui-expand>
        </tui-accordion>
      </section>
    }
  </div>
</tui-elastic-container>
